"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const kioskInteractions_1 = require("./kioskInteractions");
const hiddenExit_1 = require("./hiddenExit");
const playSessionUI_1 = require("./playSessionUI");
const duck_1 = require("./objects/duck");
const water_1 = require("./water");
const workspace_1 = require("./workspace");
const resetTiming_1 = require("./resetTiming");
const sizeLimits_1 = require("./objects/sizeLimits");
const appUpdates_1 = require("./appUpdates");
const hotAirBalloon_1 = require("./objects/hotAirBalloon");
const sceneGround_1 = require("./sceneGround");
const activation_1 = require("./activation");
const balloonMaterials_1 = require("./objects/balloonMaterials");
const apple_1 = require("./objects/apple");
const paintBalloon_1 = require("./objects/paintBalloon");
const objectPicker_1 = require("./objectPicker");
const objectDefinitions_1 = require("./objects/objectDefinitions");
const balloon_1 = require("./objects/balloon");
const physics_1 = require("./physics");
const deviceMotion_1 = require("./deviceMotion");
const ThemeManager_1 = require("./theme/ThemeManager");
const background_1 = require("./theme/background");
const colors_1 = require("./theme/colors");
const audio_1 = require("./audio");
function requireCanvas() {
    const element = document.querySelector('#app');
    if (!element)
        throw new Error('Canvas not found');
    return element;
}
function requireContext(element) {
    const context = element.getContext('2d', { alpha: true });
    if (!context)
        throw new Error('2D canvas unavailable');
    return context;
}
void (0, balloonMaterials_1.preloadBalloonMaterials)();
const canvas = requireCanvas();
const ctx = requireContext(canvas);
let balloonViewActive = true;
void (0, audio_1.preloadSounds)().catch(error => console.warn("Sound preload failed:", error));
const isMobile = window.matchMedia('(pointer: coarse)').matches;
(0, kioskInteractions_1.setupKioskInteractions)();
(0, appUpdates_1.setupAppUpdates)();
(0, audio_1.setupAudioGestures)();
canvas.addEventListener('contextmenu', e => {
    e.preventDefault();
});
const balloonConfig = {
    ...balloon_1.defaultBalloonConfig,
    initialRadius: isMobile ? 22 : 40,
    minRadius: isMobile ? 18 : 24,
    maxRadius: isMobile ? 100 : 190,
    maxRadiusScreenRatio: isMobile ? 0.24 : 0.27,
    maxObjectAreaRatio: 0.12,
    maxSceneAreaRatio: isMobile ? 1.25 : 1.5,
    growthRate: isMobile ? 45 : 80,
    maxScreenRatio: isMobile ? 0.65 : 1 / 2.75
};
const balloons = [];
const activePointers = new Map();
const themeManager = new ThemeManager_1.ThemeManager();
const background = new background_1.BackgroundRenderer();
let customBackground = null;
(0, objectPicker_1.setupObjectPicker)(themeManager);
function applyTheme() {
    const theme = themeManager.current;
    const label = document.getElementById("counter-label");
    if (label)
        label.innerText = theme.finishMode === "random" ? "OBJECTS" : theme.finish === "duck" ? "RUBBER DUCKS" : theme.finish === "apple" ? "APPLES" : theme.finish === "watermelon" ? "WATERMELONS" : theme.finish === "bubble" ? "BUBBLES" : "BALLOONS";
    void background.setBackground(customBackground ?? theme.theme.background);
}
applyTheme();
themeManager.subscribe(applyTheme);
let width = 0;
let height = 0;
let groundY = 0;
const scenePresence = new sceneGround_1.ScenePresence();
let scenery = { ground: false, water: false };
let previousCount = -1;
let lastTime = 0;
// For popping balloons sequentially when reset is pressed
let resetQueue = [];
let resetStartedAt = 0;
let resetCount = 0;
let resetting = false;
const counterEl = document.getElementById('counter');
const hiddenExit = new hiddenExit_1.HiddenExitSequence();
if (counterEl)
    (0, activation_1.bindActivation)(counterEl, () => {
        hiddenExit.press('counter', performance.now());
        void (0, deviceMotion_1.enableDeviceMotion)().then(enabled => {
            counterEl.style.color = enabled ? 'green' : 'red';
            counterEl.title = enabled ? 'Motion enabled' : 'Motion unavailable or permission denied';
        });
    });
// iOS requires a gesture to ask for sensor access. This also works in simple mode.
let motionRequested = false;
const requestMotion = (event) => {
    if (!event.isTrusted || motionRequested)
        return;
    motionRequested = true;
    void (0, deviceMotion_1.enableDeviceMotion)();
};
for (const name of ['touchend', 'pointerup', 'click'])
    document.addEventListener(name, requestMotion, { capture: true, passive: true });
let currentDpr = 0;
let currentPixelWidth = 0;
let currentPixelHeight = 0;
function syncGround() {
    scenery = scenePresence.update(balloons, performance.now());
    const state = (0, sceneGround_1.sceneGround)(height, balloons, scenery.ground);
    groundY = state.y;
    const ground = document.getElementById('ground');
    if (ground) {
        ground.hidden = !state.visible;
        ground.style.height = `${height - groundY}px`;
    }
}
function resize() {
    if (!balloonViewActive)
        return;
    const rect = canvas.getBoundingClientRect();
    const nextWidth = rect.width;
    const nextHeight = rect.height;
    if (nextWidth <= 0 || nextHeight <= 0)
        return;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const pixelWidth = Math.round(nextWidth * dpr);
    const pixelHeight = Math.round(nextHeight * dpr);
    if (pixelWidth === currentPixelWidth &&
        pixelHeight === currentPixelHeight &&
        dpr === currentDpr &&
        nextWidth === width &&
        nextHeight === height) {
        return;
    }
    currentDpr = dpr;
    currentPixelWidth = pixelWidth;
    currentPixelHeight = pixelHeight;
    width = nextWidth;
    height = nextHeight;
    syncGround();
    canvas.width = pixelWidth;
    canvas.height = pixelHeight;
    ctx.setTransform(pixelWidth / width, 0, 0, pixelHeight / height, 0, 0);
}
function reset() {
    paintBalloon_1.paintLayer.clear();
    (0, audio_1.stopBurnerSound)();
    balloons.length = 0;
    scenePresence.reset();
    syncGround();
    activePointers.clear();
    (0, audio_1.stopInflateSound)();
    updateCounter();
}
function resetBalloons() {
    if (resetting)
        return;
    resetting = true;
    resetStartedAt = performance.now();
    resetQueue = balloons.filter(b => !b.popped);
    resetCount = resetQueue.length;
    // Randomize the popping order
    for (let i = resetQueue.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = resetQueue[i];
        resetQueue[i] = resetQueue[j];
        resetQueue[j] = temp;
    }
}
function updateReset() {
    if (!resetting)
        return;
    // Use elapsed real time, since simulation dt is capped on slow devices.
    const elapsed = (performance.now() - resetStartedAt) / 1000;
    const due = (0, resetTiming_1.resetPopsDue)(resetCount, elapsed);
    while (resetQueue.length > 0 &&
        resetCount - resetQueue.length < due) {
        const balloon = resetQueue.pop();
        if ((balloon.finish === 'apple' || balloon.finish === 'duck')) {
            balloon.apple = { exited: true };
        }
        else if (!balloon.popped) {
            (0, physics_1.popWithForce)(balloons, balloon);
        }
    }
    if (elapsed >= resetTiming_1.RESET_DEADLINE_SECONDS ||
        (resetQueue.length === 0 && balloons.every(balloon => (0, balloon_1.isBalloonFinished)(balloon, balloonConfig)))) {
        resetQueue.length = 0;
        reset();
        resetting = false;
    }
}
function updateCounter() {
    if (balloons.length === previousCount)
        return;
    previousCount = balloons.length;
    if (counterEl)
        counterEl.textContent = String(previousCount);
}
function update(dt) {
    syncGround();
    (0, sizeLimits_1.enforceSizeLimits)(balloons, width, groundY, balloonConfig);
    updateReset();
    for (const balloon of balloons) {
        (0, balloon_1.updateBalloon)(balloon, dt, width, groundY, balloonConfig, balloons);
    }
    (0, physics_1.updateBalloonPhysics)(balloons, dt, width, groundY, balloonConfig, (0, water_1.waterSurface)(groundY, balloons, scenery.water));
    for (let i = balloons.length - 1; i >= 0; i--) {
        const balloon = balloons[i];
        if ((0, balloon_1.isBalloonFinished)(balloon, balloonConfig)) {
            if (balloon.pointerId !== null)
                releaseBalloon(balloon.pointerId);
            balloons.splice(i, 1);
        }
    }
    syncGround();
    updateCounter();
    syncInflateSound();
    let burnerIntensity = 0;
    if (!document.hidden) {
        for (const balloon of balloons)
            if (!balloon.popped)
                burnerIntensity += balloon.burner?.intensity ?? 0;
    }
    (0, audio_1.setBurnerSoundLevel)(burnerIntensity);
}
// function render(): void {
//     ctx.clearRect(0, 0, canvas.width, canvas.height)
//     for (const balloon of balloons) {
//         drawBalloon(ctx, balloon)
//     }
// }
function render() {
    // The context already maps CSS coordinates to backing pixels, including DPR < 1.
    ctx.clearRect(0, 0, width, height);
    paintBalloon_1.paintLayer.draw(ctx, width, height, currentDpr);
    const surface = (0, water_1.waterSurface)(groundY, balloons, scenery.water);
    (0, water_1.drawWater)(ctx, width, groundY, surface, (0, water_1.waterTime)());
    for (const balloon of balloons) {
        (0, balloon_1.drawBalloon)(ctx, balloon);
    }
    (0, water_1.drawWater)(ctx, width, groundY, surface, (0, water_1.waterTime)(), true);
}
let profileFrames = 0;
let profileUpdate = 0;
let profileRender = 0;
let profileStart = performance.now();
function frame(time) {
    if (!balloonViewActive || document.hidden) {
        lastTime = 0;
        requestAnimationFrame(frame);
        return;
    }
    if (lastTime === 0)
        lastTime = time;
    const dt = Math.min((time - lastTime) / 1000, 1 / 30);
    lastTime = time;
    const t0 = performance.now();
    (0, physics_1.updateBreeze)(dt);
    update(dt);
    const t1 = performance.now();
    render();
    const t2 = performance.now();
    profileUpdate += t1 - t0;
    profileRender += t2 - t1;
    profileFrames++;
    if (time - profileStart >= 5000) {
        console.log({
            balloons: balloons.length,
            fps: Math.round(profileFrames * 1000 /
                (time - profileStart)),
            physicsMs: +(profileUpdate / profileFrames).toFixed(2),
            renderMs: +(profileRender / profileFrames).toFixed(2)
        });
        profileFrames = 0;
        profileUpdate = 0;
        profileRender = 0;
        profileStart = time;
    }
    requestAnimationFrame(frame);
}
function canvasPosition(event) {
    const rect = canvas.getBoundingClientRect();
    return {
        x: (event.clientX - rect.left) * width / rect.width,
        y: (event.clientY - rect.top) * height / rect.height
    };
}
canvas.addEventListener('contextmenu', event => event.preventDefault());
let runAudioInit = true;
const basketDrags = new Map();
canvas.addEventListener('pointerdown', event => {
    if (runAudioInit) {
        runAudioInit = false;
        (0, audio_1.unlockAudio)(true);
    }
    else {
        (0, audio_1.unlockAudio)();
    }
    event.preventDefault();
    if (resetting)
        return;
    const { x, y } = canvasPosition(event);
    for (let i = balloons.length - 1; i >= 0; i--) {
        const balloon = balloons[i];
        if (!(0, balloon_1.containsPoint)(balloon, x, y))
            continue;
        // A balloon being inflated by another pointer is not popped.
        if (balloon.pointerId !== null)
            return;
        if (balloon.finish === 'hot-air' && (0, hotAirBalloon_1.containsBasketPoint)(balloon, x, y)) {
            balloon.pointerId = event.pointerId;
            balloon.growing = false;
            balloon.anchorX = balloon.x;
            balloon.anchorY = balloon.y;
            basketDrags.set(event.pointerId, { x, y });
            activePointers.set(event.pointerId, balloon);
            canvas.setPointerCapture(event.pointerId);
            return;
        }
        if ((balloon.finish === 'apple' || balloon.finish === 'duck')) {
            if (balloon.finish === 'duck') {
                balloon.duckPress = 1;
                (0, audio_1.playDuckCall)(balloon.duckVariant === 'goose');
            }
            (0, apple_1.sampleAppleDrag)(balloon, x, y, event.timeStamp);
            balloon.pointerId = event.pointerId;
            balloon.anchorX = balloon.x;
            balloon.anchorY = balloon.y;
            activePointers.set(event.pointerId, balloon);
            canvas.setPointerCapture(event.pointerId);
            return;
        }
        (0, physics_1.popWithForce)(balloons, balloon);
        return;
    }
    const finish = themeManager.finishForPointer();
    const balloon = {
        pointerId: event.pointerId,
        x,
        y,
        vx: 0,
        vy: 0,
        anchorX: x,
        anchorY: y,
        radius: finish === "duck" ? (isMobile ? 30 : 42) : finish === "apple" ? (isMobile ? 23 : 30) : finish === "watermelon" ? (isMobile ? 30 : 42) : balloonConfig.initialRadius,
        color: themeManager.randomBalloonColor(finish),
        panelColors: (0, colors_1.getRandomPanelColors)(themeManager.current.theme, Math.max(1, Math.floor(Math.random() * 5))),
        finish,
        foil: finish === 'latex' && Math.random() < 0.18,
        angle: (finish === "hot-air" || finish === "duck") ? 0 : Math.random() * Math.PI * 2,
        angularVelocity: 0,
        growing: finish !== "apple",
        popped: false,
        popTime: 0
    };
    if (balloon.finish === "duck")
        Object.assign(balloon, (0, duck_1.randomDuckAppearance)());
    const maxSize = (0, sizeLimits_1.maximumRadius)(width, groundY, balloonConfig);
    const room = (0, sizeLimits_1.availableRadius)(balloon, balloons, width, groundY, balloonConfig);
    const minimum = Math.min(balloonConfig.minRadius ?? balloonConfig.initialRadius, maxSize);
    if (room < minimum || maxSize <= 0)
        return;
    balloon.radius = Math.max(minimum, Math.min(balloon.radius, maxSize, room));
    if ((balloon.finish === "apple" || balloon.finish === "duck"))
        (0, apple_1.sampleAppleDrag)(balloon, x, y, event.timeStamp);
    balloons.push(balloon);
    playSession.objectCreated();
    syncGround();
    activePointers.set(event.pointerId, balloon);
    canvas.setPointerCapture(event.pointerId);
    if (activePointers.size === 1 && balloon.finish !== "watermelon" && balloon.finish !== "apple" && balloon.finish !== "duck")
        (0, audio_1.startInflateSound)(balloon.finish);
    updateCounter();
});
canvas.addEventListener('pointermove', event => {
    const balloon = activePointers.get(event.pointerId);
    try {
        if (!balloon || balloon.popped)
            return;
        const { x, y } = canvasPosition(event);
        const drag = basketDrags.get(event.pointerId);
        if (drag) {
            (0, hotAirBalloon_1.moveHotAirAssembly)(balloon, x - drag.x, y - drag.y);
            drag.x = x;
            drag.y = y;
            return;
        }
        if ((balloon.finish === "apple" || balloon.finish === "duck"))
            (0, apple_1.sampleAppleDrag)(balloon, x, y, event.timeStamp);
        balloon.anchorX = x;
        balloon.anchorY = y;
    }
    catch {
        if (balloon) {
            balloon.anchorX = screenX / 2;
            balloon.anchorY = screenY / 2;
        }
    }
});
function releaseBalloon(pointerId, time = performance.now()) {
    const basketDrag = basketDrags.delete(pointerId);
    const balloon = activePointers.get(pointerId);
    if (!balloon)
        return;
    activePointers.delete(pointerId);
    balloon.pointerId = null;
    balloon.growing = false;
    if ((balloon.finish === "apple" || balloon.finish === "duck"))
        (0, apple_1.releaseAppleThrow)(balloon, time);
    if (!balloon.popped && !basketDrag && balloon.finish !== "apple" && balloon.finish !== "duck") {
        const angle = Math.random() * Math.PI * 2;
        const { releaseImpulse } = (0, objectDefinitions_1.getPhysicsOptions)(balloon, balloonConfig);
        const impulse = Math.max(releaseImpulse / 2, releaseImpulse * (0.9 + Math.random() * 0.5));
        balloon.vx += Math.cos(angle) * impulse;
        balloon.vy += Math.sin(angle) * impulse;
        balloon.angularVelocity += (Math.random() - 0.5) * 0.5;
    }
    if (activePointers.size === 0)
        (0, audio_1.stopInflateSound)();
}
let lastInflating = false;
let lastInflateFinish = null;
function syncInflateSound() {
    const balloon = balloons.find(balloon => balloon.finish !== "watermelon" && balloon.finish !== "apple" && balloon.finish !== "duck" &&
        balloon.growing &&
        !balloon.popped &&
        balloon.pointerId !== null);
    const finish = balloon?.finish ?? 'latex';
    const inflating = !!balloon && !document.hidden;
    if (inflating === lastInflating &&
        (!inflating || finish === lastInflateFinish)) {
        return;
    }
    lastInflating = inflating;
    lastInflateFinish = inflating ? finish : null;
    if (inflating) {
        (0, audio_1.startInflateSound)(finish);
    }
    else {
        (0, audio_1.stopInflateSound)();
    }
}
function cancelCanvasPointers() {
    activePointers.clear();
    basketDrags.clear();
    for (const balloon of balloons) {
        if (balloon.pointerId === null)
            continue;
        const pointerId = balloon.pointerId;
        balloon.pointerId = null;
        balloon.growing = false;
        if (canvas.hasPointerCapture(pointerId))
            canvas.releasePointerCapture(pointerId);
    }
    (0, audio_1.stopBurnerSound)();
    (0, audio_1.stopInflateSound)();
}
canvas.addEventListener('pointerup', event => {
    const apple = activePointers.get(event.pointerId);
    if (apple && (apple.finish === 'apple' || apple.finish === 'duck')) {
        const { x, y } = canvasPosition(event);
        (0, apple_1.sampleAppleDrag)(apple, x, y, event.timeStamp);
    }
    releaseBalloon(event.pointerId, event.timeStamp);
});
canvas.addEventListener('pointercancel', event => releaseBalloon(event.pointerId));
canvas.addEventListener('lostpointercapture', event => releaseBalloon(event.pointerId));
// Backgrounding
window.addEventListener('blur', cancelCanvasPointers);
window.addEventListener('pagehide', cancelCanvasPointers);
document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
        cancelCanvasPointers();
    }
});
window.addEventListener('resize', resize);
if (typeof ResizeObserver !== 'undefined')
    new ResizeObserver(resize).observe(canvas);
window.addEventListener('orientationchange', () => {
    requestAnimationFrame(resize);
    window.setTimeout(resize, 100);
    window.setTimeout(resize, 350);
});
window.visualViewport?.addEventListener('resize', resize);
const resetButton = document.getElementById('reset');
if (resetButton)
    (0, activation_1.bindActivation)(resetButton, () => {
        if (hiddenExit.press('reset', performance.now()))
            (0, hiddenExit_1.exitAppFullscreen)();
        else
            resetBalloons();
    });
const sketchLink = document.querySelector('.sketch-button');
if (sketchLink)
    (0, activation_1.bindActivation)(sketchLink);
// background.addEventListener('load', drawBackground)
// background.src = '/bg.png'
const playSession = (0, playSessionUI_1.setupPlaySession)(cancelCanvasPointers);
(0, workspace_1.setupWorkspace)({
    showScreensaver: () => playSession.showScreensaver(),
    resolveView(view) { return playSession.resolveView(view); },
    setSimpleMode(enabled) { themeManager.setSimpleMode(enabled); },
    showBalloons(active) {
        if (!active) {
            for (const pointerId of [...activePointers.keys()]) {
                releaseBalloon(pointerId);
                if (canvas.hasPointerCapture(pointerId))
                    canvas.releasePointerCapture(pointerId);
            }
            (0, audio_1.stopInflateSound)();
            (0, audio_1.stopBurnerSound)();
            lastInflating = false;
            lastInflateFinish = null;
        }
        balloonViewActive = active;
        lastTime = 0;
        profileStart = performance.now();
        profileFrames = profileUpdate = profileRender = 0;
        if (active)
            resize();
    },
    async setBackground(url) {
        customBackground = url;
        await background.setBackground(url ?? themeManager.current.theme.background);
    }
});
resize();
updateCounter();
requestAnimationFrame(frame);
//# sourceMappingURL=index.js.map